import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

/*
  Generated class for the SettingsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingsProvider {

  private version: number = 2;

  private state$: ReplaySubject<Settings> = new ReplaySubject<Settings>(1);

  public settings$: Observable<Settings> = this.state$.asObservable();

  constructor(private storage: Storage) {
    this.settings$.subscribe(settings => {
      this.storage.set('settings', settings);
    });

    this.storage.ready().then(_ => {
      this.storage.get('settings').then(settings => {
        if (settings && settings.version && settings.version == this.version) {
          this.state$.next(settings);
        } else {
          this.reset();
        }
      });
    });
  }

  public Update(settings: Settings) {
    this.state$.next(settings);
  }

  public addProduct(name: string): Observable<Product> {
    return this.settings$.pipe(
      first(),
      map(settings => {
        var max = settings.products.reduce((prev, current) => {
          if (!prev || current.id > prev.id) {
            return current;
          } else {
            return prev;
          }
        });

        var product = { id: max.id + 1, group: "Overige", name: name };
        settings.products.push(product);
        this.state$.next(settings);

        return product;
      }));
  }

  public reset() {
    this.state$.next({
      version: this.version,
      name: null,
      ice: true,
      products: [
        { id: 1, group: "Dranken", name: "Water", options: [{ id: 2, name: "Pomelo" }, { id: 3, name: "Slimpie" }, { id: 1, name: 'met ijs' }] },
        { id: 2, group: "Dranken", name: "Sap", options: [{ id: 1, name: 'met ijs' }] },
        { id: 3, group: "Dranken", name: "Koffie" },
        { id: 4, group: "Dranken", name: "Thee" },

        { id: 5, group: "Frisdranken", name: "Spa", options: [{ id: 4, name: "Blauw" }, { id: 5, name: "Rood" }, { id: 6, name: "Bosvruchten" }, { id: 1, name: 'met ijs' }] },
        { id: 6, group: "Frisdranken", name: "Cola", options: [{ id: 7, name: 'Light' }, { id: 1, name: 'met ijs' }] },
        { id: 7, group: "Frisdranken", name: "Fanta", options: [{ id: 2, name: "Pomelo" }, { id: 1, name: 'met ijs' }] },
        { id: 8, group: "Frisdranken", name: "Cassis", options: [{ id: 1, name: 'met ijs' }] },

        { id: 9, group: "Frisdranken", name: "Sprite", options: [{ id: 1, name: 'met ijs' }] },
        { id: 10, group: "Frisdranken", name: "Ginger Ale", options: [{ id: 1, name: 'met ijs' }] },
        { id: 11, group: "Frisdranken", name: "Bitter Lemon", options: [{ id: 1, name: 'met ijs' }] },
        { id: 12, group: "Frisdranken", name: "Tonic", options: [{ id: 1, name: 'met ijs' }] },

        { id: 13, group: "Alcoholisch", name: "Bier", options: [{ id: 8, name: "0.0%" }, { id: 9, name: "met glas" }] },
        { id: 14, group: "Alcoholisch", name: "Radler", options: [{ id: 8, name: "0.0%" }, { id: 9, name: "met glas" }] },
        { id: 15, group: "Alcoholisch", name: "Wiskey", options: [{ id: 10, name: "Cola" }, { id: 11, name: "Cola Light" }, { id: 12, name: "Ginger Ale" }, { id: 13, name: "Sprite" }, { id: 1, name: 'met ijs' }] },
        { id: 16, group: "Alcoholisch", name: "Bacardi", options: [{ id: 10, name: "Cola" }, { id: 11, name: "Cola Light" }, { id: 12, name: "Ginger Ale" }, { id: 13, name: "Sprite" }, { id: 1, name: 'met ijs' }] },

        { id: 17, group: "Alcoholisch", name: "Wit", options: [{ id: 14, name: "Droog" }, { id: 15, name: "Zoet" }] },
        { id: 18, group: "Alcoholisch", name: "Rose", options: [{ id: 14, name: "Droog" }, { id: 15, name: "Zoet" }, { id: 1, name: 'met ijs' }] },
        { id: 19, group: "Alcoholisch", name: "Rood" },
        { id: 20, group: "Alcoholisch", name: "Sherry" },

        { id: 21, group: "Alcoholisch", name: "Lic 43", options: [{ id: 10, name: "Cola" }, { id: 11, name: "Cola Light" }, { id: 12, name: "Ginger Ale" }, { id: 13, name: "Sprite" }, { id: 1, name: 'met ijs' }] },
        { id: 22, group: "Alcoholisch", name: "South Conf", options: [{ id: 1, name: 'met ijs' }] },
        { id: 23, group: "Alcoholisch", name: "Bailey", options: [{ id: 1, name: 'met ijs' }] }
      ],
      tables: [
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" },
        { id: 5, name: "5" },
        { id: 6, name: "6" },
        { id: 7, name: "7" },
        { id: 8, name: "8" },
        { id: 9, name: "" },
        { id: 10, name: "BAR" },
        { id: 11, name: "" },
        { id: 12, name: "" },
        { id: 13, name: "" },
        { id: 14, name: "" },
        { id: 15, name: "" },
        { id: 16, name: "" },
        { id: 17, name: "" },
        { id: 18, name: "" },
        { id: 19, name: "" },
        { id: 20, name: "" },
        { id: 21, name: "" },
        { id: 22, name: "" },
        { id: 23, name: "" },
        { id: 24, name: "" }
      ]
    });
  }
}

export class Settings {
  version: number;
  name: string;
  ice: boolean;
  products: Product[];
  tables: Table[];
}

export class Product {
  id: number;
  group: string;
  name: string;
  options?: ProductOption[];
}


export class ProductOption {
  id: number;
  name: string;
}

export class Table {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts